export const targetGroupsListConstants = {
  TARGET_GROUPS_LIST_LOADING: "TARGET_GROUPS_LIST_LOADING",
  TARGET_GROUPS_LIST_SUCCESS: "TARGET_GROUPS_LIST_SUCCESS",
  TARGET_GROUPS_LIST_FAILURE: "TARGET_GROUPS_LIST_FAILURE",
};

export const targetGroupsFuseConstants = {
  TARGET_GROUPS_FUSE_LIST_LOADING: "TARGET_GROUPS_FUSE_LIST_LOADING",
  TARGET_GROUPS_FUSE_LIST_SUCCESS: "TARGET_GROUPS_FUSE_LIST_SUCCESS",
  TARGET_GROUPS_FUSE_LIST_FAILURE: "TARGET_GROUPS_FUSE_LIST_FAILURE",
};

export const targetGroupsHm5Constants = {
  TARGET_GROUPS_HM5_LIST_LOADING: "TARGET_GROUPS_HM5_LIST_LOADING",
  TARGET_GROUPS_HM5_LIST_SUCCESS: "TARGET_GROUPS_HM5_LIST_SUCCESS",
  TARGET_GROUPS_HM5_LIST_FAILURE: "TARGET_GROUPS_HM5_LIST_FAILURE",
};

export const targetGroupsHmplusConstants = {
  TARGET_GROUPS_HMPLUS_LIST_LOADING: "TARGET_GROUPS_HMPLUS_LIST_LOADING",
  TARGET_GROUPS_HMPLUS_LIST_SUCCESS: "TARGET_GROUPS_HMPLUS_LIST_SUCCESS",
  TARGET_GROUPS_HMPLUS_LIST_FAILURE: "TARGET_GROUPS_HMPLUS_LIST_FAILURE",
};

export const targetGroupsUAConstants = {
  TARGET_GROUPS_UA_LIST_LOADING: "TARGET_GROUPS_UA_LIST_LOADING",
  TARGET_GROUPS_UA_LIST_SUCCESS: "TARGET_GROUPS_UA_LIST_SUCCESS",
  TARGET_GROUPS_UA_LIST_FAILURE: "TARGET_GROUPS_UA_LIST_FAILURE",
};

export const targetGroupsSaConstants = {
  TARGET_GROUPS_SA_LIST_LOADING: "TARGET_GROUPS_SA_LIST_LOADING",
  TARGET_GROUPS_SA_LIST_SUCCESS: "TARGET_GROUPS_SA_LIST_SUCCESS",
  TARGET_GROUPS_SA_LIST_FAILURE: "TARGET_GROUPS_SA_LIST_FAILURE",
};

export const targetGroupsVs2jen2Constants = {
  TARGET_GROUPS_VS2JEN2_LIST_LOADING: "TARGET_GROUPS_VS2JEN2_LIST_LOADING",
  TARGET_GROUPS_VS2JEN2_LIST_SUCCESS: "TARGET_GROUPS_VS2JEN2_LIST_SUCCESS",
  TARGET_GROUPS_VS2JEN2_LIST_FAILURE: "TARGET_GROUPS_VS2JEN2_LIST_FAILURE",
};

export const targetGroupsVs2ngaConstants = {
  TARGET_GROUPS_VS2NGA_LIST_LOADING: "TARGET_GROUPS_VS2NGA_LIST_LOADING",
  TARGET_GROUPS_VS2NGA_LIST_SUCCESS: "TARGET_GROUPS_VS2NGA_LIST_SUCCESS",
  TARGET_GROUPS_VS2NGA_LIST_FAILURE: "TARGET_GROUPS_VS2NGA_LIST_FAILURE",
};
